import { FormControl } from '@angular/forms';
import { QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { QuestionForm } from './question-form.model';

export class QuestionFormAIChat extends QuestionForm {
  constructor() {
    super();
    this.extendFormGroup();
  }

  initEmpty(index: number, pageId: string): void {
    super.initEmpty(index, pageId);
    this.form.get('title').setValue('');
    this.form.get('type').setValue(QuestionType.AIChat);
  }

  init(question: Question): void {
    super.init(question);
  }

  private extendFormGroup(): void {
    this.form.addControl('startingQuestion', new FormControl<string>('', { nonNullable: true }));
    this.form.addControl('promptsNumber', new FormControl<number>(3, { nonNullable: true }));
    this.form.addControl('minPromptsNumber', new FormControl<number>(1, { nonNullable: true }));
    this.form.addControl('discussionGuide', new FormControl<string>('', { nonNullable: true }));
    this.form.addControl('allowVoiceResponsesInd', new FormControl<boolean>(true, { nonNullable: true }));
  }
}
